import { useInvoiceTable } from "Order/Modules/Invoice/Components/Tables/Hooks/useInvoiceListTable";
import { Table } from "Shared/Components/Table";
import type { FC } from "react";

type Props = {
	partnerId: number;
};

export const PartnerInvoiceTab: FC<Props> = ({ partnerId }) => {
	const tableOptions = useInvoiceTable({ partnerId });

	return (
		<>
			<Table tableOptions={tableOptions} />
		</>
	);
};
